import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function codeFormatValidator(): ValidatorFn {
  const pattern = /^\d{6}[A-Z]{2}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null; // don't validate empty values - use Validators.required for that
    }

    const isValid = pattern.test(value);
    return isValid ? null : { invalidCodeFormat: true };
  };
}
